var _path, _path2, _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackgroundDefault(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 940",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2F7",
    d: "M0 0h1440v940H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M0 0h1440v940H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "background-default_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 940
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v940H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#background-default_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -209,
    cy: 58,
    r: 440,
    fill: "url(#background-default_svg__paint0_radial)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 1136,
    r: 720,
    fill: "url(#background-default_svg__paint1_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "background-default_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 440 -440 0 -209 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131112"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background-default_svg__paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 720 -720 0 962 1136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083E7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131112"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDefault);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI5NDAiIHZpZXdCb3g9IjAgMCAxNDQwIDk0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE0NDAiIGhlaWdodD0iOTQwIiBmaWxsPSIjRjBGMkY3Ii8+CjxyZWN0IHdpZHRoPSIxNDQwIiBoZWlnaHQ9Ijk0MCIgZmlsbD0iIzEyMTIxMiIvPgo8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNDQwIiBoZWlnaHQ9Ijk0MCI+CjxyZWN0IHdpZHRoPSIxNDQwIiBoZWlnaHQ9Ijk0MCIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjxjaXJjbGUgY3g9Ii0yMDkiIGN5PSI1OCIgcj0iNDQwIiBmaWxsPSJ1cmwoI3BhaW50MF9yYWRpYWwpIi8+CjxjaXJjbGUgY3g9Ijk2MiIgY3k9IjExMzYiIHI9IjcyMCIgZmlsbD0idXJsKCNwYWludDFfcmFkaWFsKSIvPgo8L2c+CjxkZWZzPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWwiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIwOSA1OCkgcm90YXRlKDkwKSBzY2FsZSg0NDApIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzRGMDAwRCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxMzExMTIiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDFfcmFkaWFsIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDk2MiAxMTM2KSByb3RhdGUoOTApIHNjYWxlKDcyMCkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDgzRTdCIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzEzMTExMiIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };